export default __webpack_public_path__ + "static/media/prototypeBg.f2984d63.webp";